<template>
  <div class="auditoria-page">
    <DataTable
      title="Concursos"
      subtitle="Dados gerais (inclui registros excluídos)"
      title-icon="fas fa-clipboard-list"
      :data="items"
      :columns="columns"
      :loading="loading"
      :custom-filters="filters"
      search-placeholder="Buscar por título, prefeitura ou tipo..."
      empty-title="Nenhum concurso encontrado"
      empty-message="Não há concursos disponíveis para auditoria."
      empty-icon="fas fa-clipboard-list"
      :show-view="false"
      :show-edit="false"
      :show-delete="false"
      @filter="onFilter"
    >
      <template #header-actions>
        <button class="btn btn-success" @click="exportar" :disabled="exporting">
          <i :class="exporting ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i>
          {{ exporting ? 'Exportando...' : 'Exportar' }}
        </button>
      </template>

      <template #cell-deleted_at="{ value }">
        <span v-if="value" class="badge badge-danger">Excluído</span>
        <span v-else class="badge badge-success">Ativo</span>
      </template>

      <template #cell-status="{ value }">
        <span class="badge" :class="getStatusBadgeClass(value)">{{ value || '-' }}</span>
      </template>
    </DataTable>
  </div>
</template>

<script>
import axios from 'axios'
import DataTable from '@/components/admin/DataTable.vue'

export default {
  name: 'AuditoriaConcursos',
  components: { DataTable },
  data() {
    return {
      loading: false,
      exporting: false,
      items: [],
      tableFilters: { search: '' },
      columns: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'prefeitura', label: 'Prefeitura', sortable: true },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'tipo', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Status', sortable: true, type: 'badge' },
        { key: 'total_inscricoes', label: 'Inscrições', sortable: true },
        { key: 'total_publicacoes', label: 'Publicações', sortable: true },
        { key: 'created_at', label: 'Criado em', sortable: true, type: 'date' },
        { key: 'deleted_at', label: 'Registro', sortable: true }
      ],
      filters: []
    }
  },
  mounted() {
    this.carregar()
  },
  methods: {
    async carregar(params = {}) {
      this.loading = true
      try {
        const { data } = await axios.get('/ps/auditoria/concursos', { params })
        this.items = Array.isArray(data) ? data : []
      } catch (e) {
        console.error('Erro ao carregar concursos auditoria:', e)
        this.$sweet.showError('Erro ao carregar concursos')
      } finally {
        this.loading = false
      }
    },
    onFilter(filters) {
      this.tableFilters = filters || { search: '' }
      // A listagem pode ficar client-side; não recarrega no servidor para manter simples.
    },
    async exportar() {
      this.exporting = true
      try {
        this.$sweet.showInfo('Gerando arquivo Excel...')
        const response = await axios.get('/ps/auditoria/concursos/exportar-excel', {
          params: this.tableFilters,
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `auditoria_concursos_${new Date().getTime()}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$sweet.showSuccess('Arquivo exportado com sucesso!')
      } catch (e) {
        console.error('Erro ao exportar concursos auditoria:', e)
        this.$sweet.showError('Erro ao exportar dados')
      } finally {
        this.exporting = false
      }
    },
    getStatusBadgeClass(status) {
      if (!status) return 'badge-secondary'
      const s = String(status).toUpperCase()
      if (s.includes('ENCERR')) return 'badge-danger'
      if (s.includes('ANDAMENTO') || s === 'A') return 'badge-info'
      return 'badge-secondary'
    }
  }
}
</script>

<style lang="scss" scoped>
.auditoria-page {
  .badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
  }
  .badge-success {
    background: rgba(40, 167, 69, 0.1);
    color: #28a745;
  }
  .badge-danger {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
  }
  .badge-info {
    background: rgba(23, 162, 184, 0.1);
    color: #17a2b8;
  }
  .badge-secondary {
    background: rgba(108, 117, 125, 0.1);
    color: #6c757d;
  }
}
</style>

